import React from "react";
import Marquee from "react-fast-marquee";
import "../styles/marque.css";

export default function Marque({ text, top = "auto", id }) {
  return (
    <div id={id} className="marquee-container" style={{ top: top }}>
      <Marquee pauseOnHover={true} className="marquee">
        {[...Array(10)].map((_, index) => (
          <span key={index}>{text}</span>
        ))}
      </Marquee>
    </div>
  );
}
